import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Paystack checkout — card, bank transfer & mobile money (NGN). Hidden until configured. */
export default function PaystackButton({ product_id, price }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/paystack/config").then((r) => setConfig(r.data)).catch(() => setConfig({ configured: false }));
  }, []);

  if (!config?.configured) return null;

  const pay = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/paystack/initialize", {
        product_id,
        callback_url: `${window.location.origin}/payment/paystack`,
      });
      window.location.href = data.authorization_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Paystack checkout failed");
      setLoading(false);
    }
  };

  return (
    <button
      onClick={pay}
      disabled={loading}
      data-testid={`paystack-button-${product_id}`}
      className="mt-2 flex w-full items-center justify-center gap-2 rounded-md border border-emerald-500/40 bg-emerald-500/10 px-4 py-2.5 text-sm font-semibold text-emerald-400 transition-colors hover:bg-emerald-500/20 disabled:opacity-60"
    >
      {loading ? "Redirecting…" : <>Pay with Paystack <span className="text-[11px] font-normal text-muted-foreground">₦ card · bank · mobile ({price})</span></>}
    </button>
  );
}
